"use client";

const { createContext, useState } = require("react");

const FiltersContext = createContext();

const FiltersProvider = ({ children }) => {
  const [filters, setFilters] = useState({
    category: null,
    genre: null,
    country: null,
    kind: null,
    contentAgeRange: null,
    sortingType: null,
  });

  const setCategory = (category) => {
    setFilters((prev) => ({ ...prev, category }));
  };

  const setGenre = (genre) => {
    setFilters((prev) => ({ ...prev, genre }));
  };

  const setCountry = (country) => {
    setFilters((prev) => ({ ...prev, country }));
  };

  const setKind = (kind) => {
    setFilters((prev) => ({ ...prev, kind }));
  };

  const setSortingType = (sortingType) => {
    setFilters((prev) => ({ ...prev, sortingType }));
  };

  const resetFilters = () => {
    setFilters({
      category: "",
      genre: "",
      country: "",
      kind: "",
      contentAgeRange: "",
      sortingType: "",
    });
  };

  return (
    <FiltersContext.Provider
      value={{
        filters,
        setCategory,
        setGenre,
        setCountry,
        setKind,
        setSortingType,
        resetFilters,
        setFilters,
      }}
    >
      {children}
    </FiltersContext.Provider>
  );
};

export { FiltersContext, FiltersProvider };
